module.exports = __webpack_public_path__ + "static/media/about03.7c0e0580.png";